import React, { createContext, useContext } from 'react';

const initialState = {
    show: ""
}

const GlobalContext = createContext(initialState);

export const GlobalContextProvider = (props) => <GlobalContext.Provider value={initialState}>{props.children}</GlobalContext.Provider>;

export const useGlobalContext = () => useContext(GlobalContext);